import { createReducer } from "@reduxjs/toolkit";
import type { BatchEnrollmentCandidateVM } from "@shared-kernel/application/ports/admin/batch-enrollment-candidate";
import type { RetrievalState } from "@redux/state/shared-types";
import { adminRetrieveBatchEnrollmentCandidateList } from "./retrieve-batch-enrollment-candidate-list";

const initialState: RetrievalState<BatchEnrollmentCandidateVM[]> = {
  fetching: "idle",
  data: [],
};

export const retrieveBatchEnrollmentCandidateListReducer = createReducer(initialState, builder => {
  builder.addCase(adminRetrieveBatchEnrollmentCandidateList.pending, state => ({ ...state, fetching: "pending" }));
  builder.addCase(adminRetrieveBatchEnrollmentCandidateList.fulfilled, (state, { payload }) => ({
    ...state,
    data: payload,
    fetching: "success",
  }));
  builder.addCase(adminRetrieveBatchEnrollmentCandidateList.rejected, state => ({ ...state, fetching: "failed" }));
});
